import React from "react";
import PropTypes from "prop-types";

const UsersWorkspaceHeader = ({
  workspaceName,
  licensedUsers,
  nonLicensedUsers,
  reservedLicenses,
}) => (
  <div
    className="user_admin__container__item"
    data-testid="users-workspace-header"
  >
    <div className="user_admin__container__item__name">
      <span>{workspaceName}</span>
    </div>
    <span className="user_admin__container__item__licensed">
      {licensedUsers}
    </span>
    <span className="user_admin__container__item__non_licensed">
      {nonLicensedUsers}
    </span>
    <span className="user_admin__container__item__reserved_licenses">
      {reservedLicenses}
    </span>
  </div>
);

export default UsersWorkspaceHeader;

UsersWorkspaceHeader.propTypes = {
  workspaceName: PropTypes.string.isRequired,
  licensedUsers: PropTypes.number.isRequired,
  nonLicensedUsers: PropTypes.number.isRequired,
  reservedLicenses: PropTypes.number.isRequired,
};
